import type { FC } from 'react';
import { TabContainer, TabPanel } from '../TabComponents';
import { RaceResultIntergrationConfigurator } from './RaceResultIntergrationConfigurator';

export const IntegrationsTab: FC = () => {
  return (
    <TabContainer title="Integrations">
      <TabPanel title="Info">
        You can activate, configure and deactivate external integrations here.
      </TabPanel>

      <TabPanel title="RACE RESULT">
        <RaceResultIntergrationConfigurator />
      </TabPanel>
    </TabContainer>
  );
};
